import React, { useState } from "react";
import { Button, Icon, Label, Confirm } from "semantic-ui-react";
import { BasicModal } from "../../../Shared";
import { useAuth } from "../../../../hooks";
import { deactivateServer } from "../../../../api";
import {
  ActivateServerForm,
  AddSimulatorsForm,
  UpdateVisoresForm, // <--- CAMBIO: Importamos el nuevo formulario
} from "../ServerForm";
import { SimPreviewGrid } from "./SimPreviewGrid";
import "./ServerItem.scss";

export function ServerItem({ server, onReload }) {
  const { accessToken } = useAuth();
  const [showDeactivate, setShowDeactivate] = useState(false);
  const [openActivate, setOpenActivate] = useState(false);
  const [openAddSims, setOpenAddSims] = useState(false);
  // <--- CAMBIO: Estado para el modal de visores
  const [openVisores, setOpenVisores] = useState(false);

  const toggleDeactivate = () => setShowDeactivate((p) => !p);
  const toggleActivate = () => setOpenActivate((p) => !p);
  const toggleAddSims = () => setOpenAddSims((p) => !p);
  // <--- CAMBIO: Toggle para visores
  const toggleVisores = () => setOpenVisores((p) => !p);

  const onConfirmDeactivate = async () => {
    try {
      await deactivateServer(accessToken, server._id);
      onReload();
    } catch (e) {
      console.error(e);
    } finally {
      toggleDeactivate();
    }
  };

  return (
    <>
      <div className="server-card">
        <div className="server-card__head">
          <div className="server-card__titles">
            <h3>{server.serverKey}</h3>
            {server.active ? (
              <Label color="green" size="mini">
                Activo
              </Label>
            ) : (
              <Label size="mini">Inactivo</Label>
            )}
          </div>

          <div className="server-card__actions">
            {/* <--- CAMBIO: Botón para gestionar Visores */}
            <Button icon labelPosition="left" onClick={toggleVisores}>
              <Icon name="eye" /> Visores
            </Button>

            <Button icon labelPosition="left" onClick={toggleAddSims}>
              <Icon name="plus" /> Simuladores
            </Button>

            {server.active ? (
              <Button
                icon
                labelPosition="left"
                color="yellow"
                onClick={toggleDeactivate}
                title="Desactivar (active=false)"
              >
                <Icon name="power off" /> Desactivar
              </Button>
            ) : (
              <Button
                icon
                labelPosition="left"
                color="teal"
                onClick={toggleActivate}
                title="Activar servidor"
              >
                <Icon name="check circle" /> Activar
              </Button>
            )}
          </div>
        </div>

        {server.institution ? (
          <div className="server-card__institution">
            {server.institution.image && (
              <img
                src={server.institution.image}
                alt={server.institution.name}
                className="server-card__institution-img"
              />
            )}
            <div className="server-card__institution-info">
              <strong>{server.institution.name}</strong>
              {server.institution.address && (
                <span>{server.institution.address}</span>
              )}
              {server.institution.email && (
                <span>{server.institution.email}</span>
              )}
            </div>
          </div>
        ) : (
          <div className="server-card__meta">
            <span>
              <strong>Centro:</strong> Sin asignar
            </span>
          </div>
        )}

        <div className="server-card__meta">
          <span>
            <strong>Simuladores:</strong>{" "}
            {Array.isArray(server.simulatorDB) ? server.simulatorDB.length : 0}
          </span>
          <span>
            <strong>Visores:</strong> {server.visores ?? 4}
          </span>
          <span>
            <strong>Creado:</strong>{" "}
            {server.created_at
              ? new Date(server.created_at).toLocaleString()
              : "—"}
          </span>
        </div>

        {/* Mini cards de simuladores */}
        <SimPreviewGrid items={server.simulatorDB || []} max={6} />
      </div>

      {/* Modal ACTIVAR solo si está INACTIVO */}
      {!server.active && (
        <BasicModal
          show={openActivate}
          close={toggleActivate}
          title="Activar servidor"
        >
          <ActivateServerForm
            onClose={toggleActivate}
            onReload={onReload}
            initialServerKey={server.serverKey}
          />
        </BasicModal>
      )}

      {/* Modal Agregar simuladores */}
      <BasicModal
        show={openAddSims}
        close={toggleAddSims}
        title="Agregar simuladores"
      >
        <AddSimulatorsForm
          onClose={toggleAddSims}
          onReload={onReload}
          serverId={server._id}
          existingIds={(server.simulatorDB || []).map((x) =>
            typeof x === "object" ? String(x._id || x.id) : String(x),
          )}
        />
      </BasicModal>

      {/* <--- CAMBIO: Modal Gestionar Visores */}
      <BasicModal
        show={openVisores}
        close={toggleVisores}
        title={`Gestionar Visores (${server.serverKey})`}
        size="tiny"
      >
        <UpdateVisoresForm
          onClose={toggleVisores}
          onReload={onReload}
          server={server}
        />
      </BasicModal>

      {/* Confirmación de desactivación */}
      <Confirm
        open={showDeactivate}
        onCancel={toggleDeactivate}
        onConfirm={onConfirmDeactivate}
        content={`¿Desactivar el servidor ${server.serverKey}?`}
        size="mini"
      />
    </>
  );
}
